namespace $.$$ {

	export class $rise_devtools_selector extends $.$rise_devtools_selector {

		document() {
			return this.$.$mol_dom_context.document
		}

		dom_node_external( next?: Element ) {
			const node = super.dom_node_external( next )
			if( !node.parentNode ) this.document().body.appendChild( node )
			return node
		}

		@ $mol_mem
		mousemove_listener() {
			$mol_wire_solid()
			if( !this.active() ) return null
			if( this.selected() ) return null

			return new this.$.$mol_dom_listener(
				this.document(),
				'mousemove',
				this.mousemove_handler,
			)
		}

		@ $mol_mem
		click_listener() {
			$mol_wire_solid()
			if( !this.active() ) return null

			return new this.$.$mol_dom_listener(
				this.document(),
				'click',
				this.click_handler,
				{ capture: true, passive: false } as any,
			)
		}

		@ $mol_mem
		keydown_listener() {
			$mol_wire_solid()
			if( !this.active() ) return null

			return new this.$.$mol_dom_listener(
				this.document(),
				'keydown',
				this.keydown_handler,
				{ passive: false },
			)
		}

		mousemove_handler = $mol_wire_async( ( event: MouseEvent )=> {
			const target = this.document().elementFromPoint( event.clientX, event.clientY )
			this.target_pick( target )
		} )

		click_handler = $mol_wire_async( ( event: MouseEvent )=> {
			if( event.defaultPrevented ) return
			const target = this.document().elementFromPoint( event.clientX, event.clientY )
			if( target && this.dom_node().contains( target ) ) return

			event.preventDefault()
			event.stopImmediatePropagation()
			this.target_pick( target )
			this.selected( true )
			this.dom_tree()
		} )

		target_pick( target: Element | null ) {
			if( !target ) {
				this.target( null )
				this.rect( null )
				this.target_id( '' )
				this.target_name( '' )
				this.target_attrs( [] )
				this.dom_tree()
				return
			}

			if( this.dom_node().contains( target ) ) return

			const attrs = target.getAttributeNames()
			this.target( target )
			this.rect( target.getBoundingClientRect() )
			this.target_id( target.id )
			this.target_name( target.tagName.toLowerCase() )
			this.target_attrs( attrs )
			this.dom_tree()
		}

		target_info() {
			return {
				id: this.target_id(),
				tag: this.target_name(),
				attrs: this.target_attrs(),
			}
		}

		keydown_handler = $mol_wire_async( ( event: KeyboardEvent )=> {
			if( event.defaultPrevented ) return
			if( event.key !== 'Escape' ) return

			this.done( event )
		} )

		reset() {
			this.target( null )
			this.rect( null )
			this.target_id( '' )
			this.target_name( '' )
			this.target_attrs( [] )
			this.selected( false )
			this.dom_tree()
		}

		destructor() {
			this.mousemove_listener()?.destructor()
			this.click_listener()?.destructor()
			this.keydown_listener()?.destructor()
			this.dom_node().remove()
			super.destructor()
		}

	}

}
